// frontend_react/src/context/AuthReadyGate.jsx

import React, { createContext, useContext, useMemo } from "react";
import PropTypes from "prop-types";

import { useLogin } from "./LoginContext";
import LoadingScreen from "../components/LoadingScreen";

export default function AuthReadyGate({ children }) {
  const { authLoading } = useLogin();

  if (authLoading) {
    return <LoadingScreen message="Connexion en cours..." />;
  }

  return <>{children}</>;
}

AuthReadyGate.propTypes = {
  children: PropTypes.node.isRequired,
};